import { ASUFooter } from "@asu/component-header-footer";

export default function Footer() {
  return <ASUFooter />;
}
